// Routes.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import NewVisit from "./components/NewVisit/NewVisit";
import SocialCards from "./components/SocialCards/SocialCards";
import SignIn from "./pages/SignIn/SignIn";
import Clientes from "./components/Clients/Clients";
import Visits from "./components/Visits/Visits";
import LastVisit from "./components/LastVisit/LastVisit";
import UpdateVisit from "./components/UpdateVisit/UpdateVisit";
import { getToken } from "./helpers";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={getToken() ? <SocialCards /> : <Navigate to="/signin" />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/newvisit/:clienteId" element={<NewVisit />} />
      <Route path="/updatevisit/:visitaId" element={<UpdateVisit />} />
      <Route path="/clients" element={<Clientes />} />
      <Route path="/visits" element={<Visits />} />
      <Route path="/lastvisit/:clienteId" element={<LastVisit />} />
    </Routes>
  );
};

export default AppRoutes;

